module.exports = __webpack_public_path__ + "static/clients-1-00d7c7e2e8d8ec3ec1fcf934f27bf59a.png";